import { tipoordenes } from "@/modules/Admision/interfaces/tablas/ICitaOrdenesTecnologia"

export enum TIPOESTADOS {
  ACTIVO = 'ACTIVO',
  INACTIVO = 'INACTIVO'
}

export enum ADMISSION_TYPE {
  FINALIZADO = 'FINALIZADO',
  ADMISIONADO = 'ADMISIONADO',
  AGENDADO = 'AGENDADO',
}

export const TIPOESTADOCITA = [
  'AGENDADO',
  'ADMISIONADO',
  'FINALIZADO',
  'CANCELADO',
  'INASISTIDO',
  'REAGENDADO'
]

export const TIPOSPROCEDIMIENTO : string[] = [
  'HISTORIA',
  'LABORATORIO',
  'PROCEDIMIENTO',
  'NOTA MEDICA',
  'ENCUESTA',
  'OTROS SERVICIOS'
]
export const TIPOSDOCUMENTOS : string[] = [
  'CONSENTIMIENTOS',
  'IMPRESION_ATENCION',
]
export const TIPOSDOCUMENTOSCOMUNES = ['DOCUMENTO_INSTITUCIONAL']
export const SITIOSTIPOSDOCUMENTOS : string[] = [
  'ADMISION',
  'ATENCION'
]
export const ESTADOSATENCIONDOCUMENTOS : string[] = [
  'ADMISIONADO',
  'FINALIZADO'
]
export type ModelValue = string | null | number | string[] | undefined
export type ModelValueRangeNumber =
  | string
  | null
  | number
  | number[]
  | undefined
/*| string
  | null
  | number
  | string[]
  | number[]
  | undefined
  | readonly string[]*/

export type ModelValueArrayString = Array<string> | null
export type SexoService = {
  text: string
  value: number
}
export const sexos :SexoService[]  = [
  {value:0,text:'AMBOS'},
  {value:1,text:'HOMBRE'},
  {value:2,text:'MUJER'},
]
export  type itemListEstados = {
   name: string, tipo: string,
   fullWidth?: boolean
}
export type listEstados = {
  items: itemListEstados[]
  dispensario?: boolean
}

export type notiCargue = {
  cantidad: number,
  total: number,
  porcentaje: number,
  mensajeUpload: string,
  closed?: boolean,
  uuid: string,
  error?: boolean
}

export enum tipoImpresionAsistencialDefault {
  HISTORIA = 'HISTORIA',
  LABORATORIOS = 'LABORATORIOS',
  PROCEDIMIENTOS = 'PROCEDIMIENTOS',
  'OTROS SERVICIOS' = 'OTROS SERVICIOS',
  PROCEDIMIENTO = 'PROCEDIMIENTO',
  PROCEDIMIENTO_ATENCION = 'PROCEDIMIENTO_ATENCION',
  INSUMOS = 'INSUMOS',
  MEDI_APLICADOS = 'MEDI_APLICADOS',
  RECETARIOS = 'RECETARIOS',
  INCAPACIDADES = 'INCAPACIDADES',
  CERTIFICADOS = 'CERTIFICADOS',
  REMISIONES = 'REMISIONES',
  VACUNA = 'VACUNA',
}

export enum tipoImpresionDefault {
  RECORDATORIO_CITA = 'RECORDATORIO_CITA',
}

export const keysOrdenes = {
  [tipoordenes.LABORATORIOS]: 'ORDEN_LABORATORIO',
  [tipoordenes.PROCEDIMIENTOS]: 'ORDEN_PROCEDIMIENTO',
  [tipoordenes.REMISIONES]: 'ORDEN_REMISION',
  [tipoordenes.RECETARIOS]: 'ORDEN_RECETARIO',
  [tipoordenes['OTROS SERVICIOS']]: 'ORDEN_OTROS_SERVICIOS'
}
export const skeletonTable = {
  filas: [
    // Barra superior (opcional) tipo título + acción
    {
      cols: [
        {
          style: 'width:80%;margin-top:10px',
          lines: [{ style: 'width:100%', class: 'h-[44px] rounded' }]
        },
        {
          style: 'width:20%;padding-left:8px;margin-top:10px',
          lines: [{ style: 'width:100%', class: 'h-[44px] rounded' }]
        }
      ]
    },
    {
      cols: [
        {
          style: 'width:100%;margin-top:20px',
          lines: [
            // HEADER (5 columnas)
            { style: 'width:95%', class: 'h-10 rounded' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' }
          ]
        },
        {
          style: 'width:100%;margin-top:20px',
          lines: [
            // HEADER (5 columnas)
            { style: 'width:95%', class: 'h-10 rounded' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' }
          ]
        },
        {
          style: 'width:100%;margin-top:20px',
          lines: [
            // HEADER (5 columnas)
            { style: 'width:95%', class: 'h-10 rounded' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' }
          ]
        },
        {
          style: 'width:100%;margin-top:20px',
          lines: [
            // HEADER (5 columnas)
            { style: 'width:95%', class: 'h-10 rounded' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' }
          ]
        },
        {
          style: 'width:100%;margin-top:20px',
          lines: [
            // HEADER (5 columnas)
            { style: 'width:95%', class: 'h-10 rounded' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' }
          ]
        },
        {
          style: 'width:100%;margin-top:20px',
          lines: [
            // HEADER (5 columnas)
            { style: 'width:95%', class: 'h-10 rounded' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
            { style: 'width:95%', class: 'h-12 rounded mt-2' },
          ]
        }
      ]
    }
  ]
}
export enum tipoImpresionAtencionDefault {
  'OTROS SERVICIOS' = 'OTROS SERVICIOS',
  HISTORIA = 'HISTORIA',
  LABORATORIOS = 'LABORATORIOS',
  PROCEDIMIENTOS = 'PROCEDIMIENTOS',
  VACUNA = 'VACUNA'
}
export enum tipoImpresionOrdenesDefault {
  'OTROS SERVICIOS' = 'OTROS SERVICIOS',
  ORDEN_LABORATORIO = 'LABORATORIOS',
  ORDEN_PROCEDIMIENTO = 'PROCEDIMIENTOS',
  PROCEDIMIENTO_ATENCION = 'PROCEDIMIENTO_ATENCION',
  PROCEDIMIENTO = 'PROCEDIMIENTO',
  INCAPACIDADES = 'INCAPACIDADES',
  CERTIFICADOS = 'CERTIFICADOS',
  ORDEN_REMISION = 'REMISIONES',
  ORDEN_RECETARIO = 'RECETARIOS'
}
/**
 * Verifica si un objeto tiene la propiedad 'text' y si es de tipo string
 * @param obj Objeto a verificar
 * @returns Tipo predicado que indica si el objeto tiene la propiedad text de tipo string
 */
const tienePropiedadText = (obj: unknown): obj is { text: string } => {
  // Verificamos primero que sea un objeto no nulo
  if (typeof obj !== 'object' || obj === null) return false

  // Verificamos que tenga la propiedad 'text' y que sea de tipo string
  return 'text' in obj && typeof (obj as Record<string, unknown>).text === 'string'
}
export const isValidHeader = (tablasPaciente:Array<unknown>) =>{
  // Verificar si tablasPaciente es null (caso donde options.visible es false)
  if (tablasPaciente === null) {
    console.log('No se muestran datos del paciente porque están configurados como no visibles')
    return false
  }
  // Si es un array, verificar si contiene datos válidos y agregarlos
  else if (Array.isArray(tablasPaciente)) {
    // Si el array tiene un solo elemento con mensaje de error, no lo agregamos
    const tieneError = tablasPaciente.length === 1 &&
                      tienePropiedadText(tablasPaciente[0]) &&
                      tablasPaciente[0].text === 'Datos del paciente no disponibles'

    if (tieneError) {
      // Agregar cada elemento del array al contenido
      console.log('No se muestran datos del paciente porque no están disponibles')
      return false
    }
  }
  return true
}
